<template>
      <v-tabs v-model="historicSelectionCurrentTab" show-arrows flat icons-and-text class="pb-4" color="grey lighten-2">
        <v-tab :key="tab.description" @click="handleExtraTabSelection(tab)" v-for="tab in tabs">
          <span>{{ tab.tabType === 'temporada' ? tab.nombre : tab.description }}</span>
          <v-icon>{{ tab.icon }}</v-icon>
        </v-tab>
      </v-tabs>
</template>

<script>

export default {

  data () {
    return {
      historicSelectionCurrentTab: 0,
      icono: null,
      extraTabSelection: null
    }
  },
  props: {
    historicTournamentSelectionMode: Boolean,
    tabs: []
  },
  methods: {
    handleExtraTabSelection (extraTabSelected) {
      this.extraTabSelection = extraTabSelected
      this.$emit('extraTabSelection', extraTabSelected)
    }
  },
  created () {
  },
  watch: {
    async tabs () {
      let index = this.tabs.findIndex(tab => tab === this.extraTabSelection)
      this.historicSelectionCurrentTab = index
    }
  }
}
</script>

<style scoped>
.top-spacing {
margin-top: 5em;
}
</style>
